import { render, staticRenderFns } from "./Pcl5.vue?vue&type=template&id=6ac86cca&scoped=true&"
import script from "./Pcl5.vue?vue&type=script&lang=ts&"
export * from "./Pcl5.vue?vue&type=script&lang=ts&"
import style0 from "./Pcl5.vue?vue&type=style&index=0&id=6ac86cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac86cca",
  null
  
)

export default component.exports